const focusedImages = document.querySelectorAll(".js-gallery-focused");
const galleryThumbnails = document.querySelectorAll(".js-gallery-thumb");

if (focusedImages.length && galleryThumbnails.length) {
  if (galleryThumbnails.length > 1) {
    let timeout;

    const thumbEventListener = (image) => {
      const prev = document.querySelector(".js-gallery-focused.--visible");
      const id = image.getAttribute("data-id");

      if (prev && prev.getAttribute("data-id") === id) return;

      const next = document.querySelector(
        `.js-gallery-focused[data-id='${id}']`
      );
      if (next) {
        next.classList.add("--visible");
      }
      if (prev) {
        prev.classList.remove("--visible");
      }
    };

    window.addEventListener("click", (e) => {
      if (e.target.classList.contains("js-gallery-thumb")) {
        thumbEventListener(e.target);
      }
    });

    window.addEventListener("mouseover", (e) => {
      if (e.target.classList.contains("js-gallery-thumb")) {
        if (!timeout) {
          timeout = setTimeout(() => {
            thumbEventListener(e.target);
          }, 150);
        }
      }
    });

    window.addEventListener("mouseout", (e) => {
      if (e.target.classList.contains("js-gallery-thumb")) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
      }
    });
  } else {
    focusedImages[0].parentNode.classList.add("--full-width");
    galleryThumbnails[0].parentNode.classList.add("--hidden");
  }
}
